import { useLayoutEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

export function LegalTabs() {
  const { key, pathname } = useLocation()

  useLayoutEffect(() => {
    const previousScrollBehavior = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = 'auto'
    window.scrollTo(0, 0)
    document.documentElement.style.scrollBehavior = previousScrollBehavior
  }, [key, pathname])

  return (
    <nav className="legal-tabs" aria-label="Legal documents">
      <NavLink
        to="/terms"
        end
        className={({ isActive }) =>
          `legal-tab${isActive ? ' legal-tab-active' : ''}`
        }
      >
        Terms of Service
      </NavLink>

      <NavLink
        to="/privacy"
        end
        className={({ isActive }) =>
          `legal-tab${isActive ? ' legal-tab-active' : ''}`
        }
      >
        Privacy Notice
      </NavLink>
    </nav>
  )
}
